import _ from 'lodash'

class MonthlyProductionController {
  constructor(MonthlyProductionService, SubscriptionService, $analytics, ProductionDetailsFormatter, UpgradeTeaser, CurrentUserService) {

    this.UpgradeTeaser = UpgradeTeaser
    this.MonthlyProductionService     = MonthlyProductionService
    this.CurrentUserService = CurrentUserService
    this.showMonthlyProductionRecords = true

    if(CurrentUserService.hasUserRole("rav-u")) {
      this.currentUserSubscriptionPlan = 'annual'
    } else {
      this.userSubscription = SubscriptionService.subscription()
      this.userSubscription.$promise.then(this.setSubscription.bind(this), this.handleUserSubscriptionError.bind(this))
    }

    this.$analytics          = $analytics
    this.Formatter           = ProductionDetailsFormatter
    this.SubscriptionService = SubscriptionService
  }

  compileMonthlyProduction(record) {
    if(record.typeOfDocument == 'Production') {
      this.monthlyProduction = this.MonthlyProductionService.queryMonthlyProduction(record.leaseId)
      this.monthlyProduction.$promise.then(this.formatRecords.bind(this), this.handleError.bind(this))
    }
  }

  handleUserSubscriptionError(err) {
    this.currentUserSubscriptionPlan = 'annual'
  }

  setSubscription(currentSubscription) {
    this.currentUserSubscriptionPlan = currentSubscription.subscription.plan
  }

  get allRecordsExpanded() {
    return  _(this.groupedYears)
            .map('visible')
            .reduce((val, next) => {return val && next})
  }

  set allRecordsExpanded(state) {
    _.map(this.groupedYears, (year) => { year.visible = state })
  }

  handleError() {
    this.errorMessage = "We could not load production data at this time"
  }

  formatRecords(monthlyProductionData) {
    this.records = _.map(monthlyProductionData.records, this.Formatter.parseMonthYear)
    this.groupedYears = this.getGroupedYears(this.records)
    this.exportableCsvRecords = this.Formatter.prepareForCsvExport(this.records)
    this.uniqueYears = this.getUniqueYears(this.records)
    
    this.firstYear   = _.head(this.uniqueYears)
    this.lastYear    = _.last(this.uniqueYears)
    this.totalMonths = _(this.groupedYears)
                        .map('records')
                        .flatten()
                        .value()
                        .length
  }

  classify(productionYear) {
    const year            = productionYear[0]
    const monthlyRecords  = productionYear[1]
    const cumulativeGas   =  _(monthlyRecords)
                              .map('gasProductionVolume')
                              .sum()

    const cumulativeOil   = _(monthlyRecords)
                            .map('oilProductionVolume')
                            .sum()

    return new MonthGroup(year, monthlyRecords, cumulativeOil, cumulativeGas)
  }

  getGroupedYears(records) {
    return _(records)
            .groupBy('date.year')
            .pairs()
            .map(this.classify)
            .reverse()
            .value()
  }

  getUniqueYears(records) {
    return _(records)
      .map('date.year')
      .sort()
      .uniq()
      .value()
  }

  toggleAllYears() {
    this.allRecordsExpanded = !this.allRecordsExpanded
  }

  openModal() {
    this.UpgradeTeaser.openModal()
  }

  track(eventType) {
    this.$analytics.eventTrack(
      'Export Button Interaction',
      {eventType: eventType}
    )
  }
}

class MonthGroup {
  constructor(year, records, totalOil, totalGas) {
    this.year     = year
    this.records  = records
    this.visible  = false
    this.totalGas = totalGas
    this.totalOil = totalOil
  }
}

MonthlyProductionController.$inject = ['MonthlyProductionService', 'SubscriptionService', '$analytics', 'ProductionDetailsFormatter', 'UpgradeTeaser', 'CurrentUserService']

export default MonthlyProductionController